import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle2, Sparkles, Heart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Navbar from '@/components/Navbar';
import confetti from 'canvas-confetti';

export default function SupportThankYou() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [celebrated, setCelebrated] = useState(false);

  useEffect(() => {
    if (!celebrated) {
      confetti({
        particleCount: 150,
        spread: 100,
        origin: { y: 0.6 },
        colors: ['#F43F5E', '#FBBF24', '#34D399']
      });
      setCelebrated(true);
    }
  }, [celebrated]);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="rounded-3xl bg-white border border-stone-100 p-12 text-center shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
          <div className="inline-flex items-center justify-center h-24 w-24 rounded-full bg-gradient-to-br from-rose-100 to-orange-100 mb-6">
            <Heart className="h-16 w-16 text-primary animate-pulse" />
          </div>
          
          <h1 className="text-4xl md:text-5xl font-heading font-extrabold tracking-tight mb-4">
            Thank You! 💝
          </h1>
          
          <p className="text-xl text-muted-foreground mb-8 max-w-xl mx-auto">
            Your support means the world to us and helps keep Even Rounds free and improving for the entire yarn crafting community!
          </p>

          <div className="rounded-2xl bg-gradient-to-br from-emerald-50 to-teal-50 border border-emerald-100 p-8 mb-8">
            <div className="flex items-center justify-center space-x-3 mb-4">
              <Sparkles className="h-6 w-6 text-accent" />
              <h2 className="text-2xl font-heading font-bold">You&apos;re Amazing!</h2>
              <Sparkles className="h-6 w-6 text-accent" />
            </div>
            <p className="text-muted-foreground">
              Thanks to supporters like you, we can continue building features, improving AI scanning, and keeping the platform accessible to everyone.
            </p>
          </div>

          <div className="space-y-4">
            <p className="text-sm text-muted-foreground">
              Your payment has been processed successfully. You&apos;ll receive a confirmation email shortly.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
              <Button
                onClick={() => navigate('/dashboard')}
                className="rounded-full bg-primary text-primary-foreground shadow-lg shadow-primary/30 hover:shadow-primary/50 transition-all duration-300 font-bold"
              >
                Back to Dashboard
              </Button>
              <Button
                onClick={() => navigate('/inventory')}
                variant="outline"
                className="rounded-full border-2 border-stone-200 hover:border-primary hover:bg-rose-50 transition-all duration-300"
              >
                View My Stash
              </Button>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-stone-100">
            <p className="text-xs text-muted-foreground">
              Want to spread the word? Share Even Rounds with fellow yarn crafters! 🧶
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
